import React from "react";
import { Link } from "react-router-dom";
import { Download, ArrowLeft } from "lucide-react";
import { Ornament } from "./Ornament";
import Seo from "./Seo";

export default function QrPage() {
  return (
    <>
      <Seo
        path="/qr"
        title="Contact QR Code — Lumière Entertainment"
        description="Scan or download the Lumière Entertainment contact QR code."
      />
      <section
        className="min-h-screen bg-[var(--lu-black)] pt-32 pb-24 grain flex items-center"
        data-testid="qr-page"
      >
        <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center">
          <p className="font-micro text-[10px] tracking-[0.3em] text-[var(--lu-gold)]">
            Scan Me
          </p>
          <h1 className="mt-4 font-serif text-[42px] sm:text-[60px] lg:text-[80px] text-[var(--lu-ivory)] leading-[1] tracking-[0.02em]">
            One scan{" "}
            <span className="italic text-[var(--lu-gold)]">to our studio.</span>
          </h1>
          <Ornament className="my-10" light />

          <div className="mx-auto w-full max-w-md bg-[var(--lu-ivory)] p-6 sm:p-10 border border-[var(--lu-gold)]">
            <img
              src="/generated/qr-contact.png"
              alt="Scan this QR code to open Lumière Entertainment's contact page"
              className="w-full"
              data-testid="qr-image"
            />
          </div>

          <p className="mt-8 text-[14px] text-ivory-70 max-w-lg mx-auto font-light leading-[1.85]">
            Print it on business cards, event signage, invitations or press
            kits. Every scan lands directly on our contact form and is
            attributed to the QR channel automatically.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="/generated/qr-contact.png"
              download="lumiere-qr.png"
              className="btn-gold text-[11px] inline-flex items-center gap-2 px-6 py-3"
              data-testid="qr-download-png"
            >
              <Download size={14} /> Download PNG
            </a>
            <a
              href="/generated/qr-contact.svg"
              download="lumiere-qr.svg"
              className="btn-gold-outline text-[11px] inline-flex items-center gap-2 px-6 py-3"
              data-testid="qr-download-svg"
            >
              <Download size={14} /> Download SVG · Vector
            </a>
            <Link
              to="/contact"
              className="text-[11px] tracking-[0.3em] uppercase text-ivory-60 hover:text-[var(--lu-gold)] inline-flex items-center gap-2 mt-2 sm:mt-0"
              data-testid="qr-back-contact"
            >
              <ArrowLeft size={12} /> Contact Page
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
